import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers } from "redux";

import authReducer from "./features/auth/authSlice";
import dashboardReducer from "./features/Dashboard/dashboardSlice";
import appointmentReducer from "./features/Appointment/appointmentSlice";
import inventoryReducer from "./features/Inventory/inventorySlice";
import languageReducer from "./features/auth/languageSlice";
import filesReducer from "./features/Appointment/Files/FilesSlice";
import notificationsReducer from "./features/notifications/notificationsSlice";
import settingsReducer from "./features/Settings/settingsSlice";
// Persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "language"], // only persist auth and language slices
};

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  appointment: appointmentReducer,
  inventory: inventoryReducer,
  language: languageReducer,
  files: filesReducer,
  notifications: notificationsReducer,
  settings: settingsReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/REGISTER",
        ],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

// Create persistor
export const persistor = persistStore(store);
export default store;
